import axios from "axios";

export const state = {
    categories: [],
};

export const getters = {
    categories: state => state.categories,
};

export const mutations = {
    setCategories(state, newValue) {
        state.categories = newValue
    },
};

export const actions = {
    fetchCategories({ commit }) {
        axios.get('/categories').then(res => {
            commit('setCategories', res.data.categories);
            
        })
    },
};
